import * as propertyTypes from "../property_types.js"

export class UiDynamicGrid extends propertyTypes.AppBaseComponentProps {

    private tableNameMetadata = new propertyTypes.TextProperty("tableName", "Table name");
    public tableName: string;

    private styleMetadata = new propertyTypes.TextProperty("style", "Style");
    public style: string;

    private applyActiveMetadata = new propertyTypes.CheckBoxProperty("applyActive", "Apply active");
    public applyActive: string;

    private applyTargetFieldMetadata = new propertyTypes.TextCheckboxProperty("applyTargetField", "Apply target field");
    public applyTargetField: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.tableNameMetadata, this.styleMetadata, this.applyActiveMetadata, this.applyTargetFieldMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}